import { Chip, Dialog, Divider, Grid } from '@material-ui/core';
import {
  FormatLineSpacingSharp,
  Height,
  HourglassEmpty,
} from '@material-ui/icons';
import DescriptionIcon from '@material-ui/icons/Description';
import RoomIcon from '@material-ui/icons/Room';
import SchoolIcon from '@material-ui/icons/SchoolRounded';
import Skeleton from '@material-ui/lab/Skeleton';
import { PaginationNumbers } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import HourglassHalf from 'components/Icons/HourglassHalf';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { min } from 'date-fns';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Details from './Details';

// import Detailed from './detailed';

const ResultsFormation = ({
  formations = [],
  info,
  setInfo,
  setPage,
  totalPage,
  load,
  isFetching,
  page,
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  // const [first, setFirst] = useState({});
  const [open, setOpen] = useState(false);

  const handleClick = (value) => {
    setInfo(value);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (formations?.length) {
      setInfo(formations[0]);
    }
  }, [formations?.length]);

  const date = new Date();

  return (
    <Grid container style={{ background: '#FFFFFF', borderRadius: '10px', height: '100%' }}>
      <div className={classes.result}>
        {formations?.map((item, index) => (
            <>
              <div className={classes.desktop}>
                <Grid
                  key={index}
                  className={classes.displayDesktop}
                  container
                  item
                  onClick={() => handleClick(item)}
                  xs={12}
                  style={{
                    padding: '20px',
                    marginTop: '8px',
                    marginBottom: '8px',
                    backgroundColor: item?.id === info?.id && `#F3F7FF`,
                    borderRadius: 20,
                    // border:
                    //   item.id === info.id
                    //     ? `3px solid #0060F9`
                    //     : `3px solid #FFFFFF`,
                  }}
                >
                  <div className={classes.descriptionContainer}>
                    <div>
                      <AvatarCompany
                        height={70}
                        idCompany={item?.school?.id}
                        name={item?.school?.name}
                        width={70}
                      />
                    </div>
                    <div className={classes.nameContainer}>
                      <div style={{ display: 'flex', fontWeight: '400', color: "#152652", alignItems: 'center', marginBottom: '4px' }}  className={global.infoText}>
                        {item.school.name}
                        <div
                          className={css({
                            marginLeft: spacing(1),
                            display: 'flex',
                          })}
                        ></div>
                        <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                      </div>
                      <div className={global.title}>{item.label}</div>
                    </div>
                  </div>
                  <Grid
                    container
                    className={css({
                      marginTop: 5,
                      gap: 10,
                      '@media only screen and (min-width:1024px) and (max-width:1350px)':
                        { margin: 0, marginTop: spacing(1) },
                    })}
                  >
                    <div className={cx(global.infoText, classes.address)}>
                      <div className={classes.flex} >
                        <HourglassHalf
                          className={global.infoIcon}
                          color={item.id === info.id ? ` #0060F9` : ` #5D75A8`}
                        />
                        <div
                          style={{
                            color:
                              item.id === info.id ? ` #152652` : ` #5D75A8`,
                          }}
                        >
                          {item?.duration} mois
                        </div>
                      </div>
                      <div className={classes.flex}>
                        <SchoolIcon
                          className={global.infoIcon}
                          style={{
                            color:
                              item.id === info.id ? ` #0060F9` : ` #5D75A8`,
                          }}
                        />
                        <div
                          style={{
                            color:
                              item.id === info.id ? ` #152652` : ` #5D75A8`,
                          }}
                        >
                          {item?.degree?.label.split(' -')[0]}
                        </div>
                      </div>
                    </div>
                    <div className={cx(global.infoText, classes.address)}>
                      <div className={classes.flex}>
                        <RoomIcon
                          className={global.infoIcon}
                          style={{
                            color:
                              item.id === info.id ? ` #0060F9` : ` #5D75A8`,
                          }}
                        />
                        <div
                          style={{
                            color:
                              item.id === info.id ? ` #152652` : ` #5D75A8`,
                          }}
                        >
                          {item.address.city} {item.address.cityCode}
                        </div>
                      </div>
                      <div className={classes.flex}>
                        <DescriptionIcon
                          className={global.infoIcon}
                          style={{
                            color:
                              item.id === info.id ? ` #0060F9` : ` #5D75A8`,
                          }}
                        />
                        <div
                          style={{
                            color:
                              item.id === info.id ? ` #152652` : ` #5D75A8`,
                          }}
                        >
                          {item?.trainingType?.label}
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <div>
                    {new Date(
                      item?.applicationStartDate?.split('T')[0]
                    ) <= date &&
                      new Date(
                        item?.applicationClosingDate?.split('T')[0]
                      ) >= date ? (
                      <Chip
                        classes={{
                          colorPrimary: css({
                            background: '#DBFAD8',
                            color: '#008000',
                          }),
                        }}
                        className={classes.chip}
                        color="primary"
                        label="Candidatures ouvertes"
                        size="small"
                      />
                    ) : (
                      <Chip
                        classes={{
                          colorPrimary: css({
                            background: '#FBD3D5',
                            color: '#F50057',
                          }),
                        }}
                        className={classes.chip}
                        color="primary"
                        label="Candidatures fermées"
                        size="small"
                      />
                    )}
                  </div>
                </Grid>
              </div>
              {index !== formations?.length - 1 ? (
                <Divider
                  style={{
                    marginBottom: '10px',
                    marginTop: '10px',
                    marginLeft: '-10px',
                    marginRight: '-10px',
                  }}
                  fullWidth
                />
              ) : (
                  <div style={{height: '10px'}}></div>
              )}
            </>
          ))
        }
        <div className={css({paddingBottom: '16px'})}>
          <PaginationNumbers
            onChange={handlePaginationChange}
            noMargin
            page={page}
            pageCount={10}
            totalCount={totalPage}
          />
        </div>
        <Dialog
          fullScreen
          className={classes.detailsModal}
          onClose={closeModal}
          open={open}
        >
          <Details
            partnersAccepted={partnersAccepted}
            partnersRequested={partnersRequested}
            partnersReceived={partnersReceived}
            handleRefetch={handleRefetch}
            accountInfos={accountInfos}
            info={info}
            closeModal={closeModal}
          />
        </Dialog>
      </div>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    '@media only screen and (max-width:1023px)': {
      display: 'flex',
      alignItems: 'flex-end',
    },
  },
  avatar: {
    height: 70,
    width: 70,
  },
  descriptionContainer: {
    display: 'flex',
    '@media only screen and (min-width:1024px) and (max-width:1350px)': {
      flexDirection: 'column',
      alignItems: 'start',
      marginLeft: 0,
    },
    marginBottom: '10px',
    alignItems: 'center',
  },
  nameContainer: {
    marginLeft: spacing(2),
  },
  result: {
    borderRadius: 10,
    padding: '10px',
    background: 'white',
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      backgroundColor: '#F3F7FF',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#0060F9',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#C0D9FF',
    },
  },
  details: {
    overflowY: 'auto',
    background: 'white',
    maxHeight: '80vh',
    '@media only screen and (max-height: 800px)': {
      maxHeight: '80vh !important',
    },
    '@media only screen and (max-height: 750px)': {
      maxHeight: '80vh !important',
    },

    borderRadius: 10,
    '@media only screen and (max-width:1023px)': { display: 'none' },
    '&::-webkit-scrollbar': {
      backgroundColor: '#F3F7FF',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#0060F9',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#C0D9FF',
    },
  },
  detailsModal: {
    display: 'flex',
    alignItems: 'flex-end',
    '@media only screen and (min-width:1024px)': { display: 'none' },
  },
  address: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    marginBottom: spacing(1),
    gap: '4px',
    position: 'relative',
  },
  displayDesktop: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F3F7FF',
    },
  },
  chip: {
    marginTop: spacing(2),
    padding: spacing(2.5),
    fontWeight: 'regular',
    borderRadius: '10.0000px',
    width: 'fit-content',
    '@media only screen and (max-width:1150px)': {
      padding: spacing(2),
      '.MuiChip-labelSmall': { padding: 0 },
    },
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
  },
  flex: {
    display: 'flex',
  }
});

ResultsFormation.propTypes = {
  formations: PropTypes.array,
  setPage: PropTypes.func,
  totalPage: PropTypes.number,
  load: PropTypes.bool,
  isFetching: PropTypes.bool,
  page: PropTypes.number,
};

export default ResultsFormation;
